// resources/js/admin/services/localeService.ts

import axios from "axios";
import { Locale, LocaleFormData } from "../types/features/Locale";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const localeService = {
  // 🔓 PUBLIC - Pas de token nécessaire (lecture) - AVEC PAGINATION
  async getAll(
    page: number = 1,
    perPage: number = 20,
    search?: string,
    isActive?: boolean,
    isRtl?: boolean
  ): Promise<PaginatedResponse<Locale>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/locales`, {
        params: { page, per_page: perPage, search, is_active: isActive, is_rtl: isRtl },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des langues", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getById(id: string): Promise<Locale> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/locales/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de la langue", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getByCode(code: string): Promise<Locale> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/locales/code/${code}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de la langue par code", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async create(token: string, data: LocaleFormData): Promise<Locale> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/locales`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de la langue", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<LocaleFormData>): Promise<Locale> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/locales/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la langue", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/locales/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de la langue", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      await axios.post(`${MAIN_API_URL}/locales/delete-many`, { ids }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};